var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generic-chart"},[(_vm.chartOptions && _vm.series && _vm.series.length)?_c('apexchart',{attrs:{"type":_vm.type,"options":_vm.chartOptions,"series":_vm.series,"xaxis":_vm.xAxis,"height":"280px"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }